export default __webpack_public_path__ + "static/media/doctors-laboratory.9aa4c025.png";